export default "__VITE_ASSET__CKYr09X3__"